export const height = window.innerHeight - 72;
